import { gql } from '@apollo/client'

export const GET_VARIATION = gql`
  query GET_VARIATION(
    $name: LD_TOGGLE_FEATURES!
    $workspaceId: ID!
    $workspace: USER_WORKSPACE_TYPE!
  ) {
    me {
      variation(
        name: $name
        workspaceId: $workspaceId
        workspaceType: $workspace
      )
    }
  }
`
